import React from "react";
import { Stack } from "@mui/system";
import {
  Typography,
  Button as MuiButton,
  Grid,
  IconButton as MuiIconButton,
} from "@mui/material";
import BadgeVisual from "../visuals/BadgeVisual";
import IconButtonWithText from "../inputs/IconButtonWithText";
import IconValueVisual from "../visuals/IconValueVisual";
export interface FeaturedEventCardProps {
  eventDay?: string;
  eventDate?: string;
  image?: string;
  eventName?: string;
  companyHost?: string;
  tag: string;
  time: string;
  location: string;
  date: string;
}
const FeaturedEventCard = ({
  eventDay,
  eventDate,
  image,
  eventName,
  companyHost,
  tag,
  time,
  location,
  date,
}: FeaturedEventCardProps) => {
  return (
    <Stack
      height={191}
      border={"2px solid #E7E7E7"}
      display="flex"
      flexDirection="row"
    >
      <Grid container>
        <Grid item xs={2} alignSelf="center">
          <Stack alignItems="center" justifyContent="center" p={2}>
            <Typography variant="h3" fontWeight={400}>
              {eventDay}
            </Typography>
            <Typography variant="h1" color="primary" fontWeight={400}>
              {eventDate}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={2}>
          <Stack alignItems="center" justifyContent="center">
            <img src={image} width={173} height={189} alt="" />
          </Stack>
        </Grid>
        <Grid item xs={6} p={2} display="grid">
          <Grid container flexDirection="row">
            <Grid item xs={4} flexDirection="column" pr={4}>
              <Typography variant="h2" fontWeight={700}>
                {eventName}
              </Typography>
              <Typography variant="h4" color="primary" fontWeight={500}>
                {companyHost}
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <BadgeVisual label={tag} borderPlacement="all" />
            </Grid>
            <Grid item xs={5}>
              <IconButtonWithText title="Interested" />
            </Grid>
          </Grid>
          <Grid container alignContent="flex-end">
            <Grid item xs={3}>
              <IconValueVisual icon="far fa-calendar-alt" value={date} />
            </Grid>
            <Grid item xs={3}>
              <IconValueVisual icon="far fa-clock" value={time} />
            </Grid>
            <Grid item xs={6}>
              <IconValueVisual icon="far fa-map-marker-alt" value={location} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2} p={2} display="grid">
          <Stack flexDirection="column" alignItems="center">
            <MuiButton
              variant="contained"
              color="primary"
              style={{ height: 45, width: 155 }}
            >
              Details
            </MuiButton>
            <Typography variant="h4" fontWeight={500}>
              Industry Categories
            </Typography>
          </Stack>
          <Stack
            flexDirection="row"
            justifyContent="space-around"
            alignItems="flex-end"
          >
            <MuiIconButton>
              <i className="far fa-star" style={{ fontSize: 16 }} />
            </MuiIconButton>
            <MuiIconButton>
              <i className="fal fa-share-alt" style={{ fontSize: 16 }} />
            </MuiIconButton>
            <MuiIconButton>
              <i className="fal fa-thumbs-up" style={{ fontSize: 16 }} />
            </MuiIconButton>
            <MuiIconButton>
              <i className="far fa-search-location" />
            </MuiIconButton>
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default FeaturedEventCard;
